module.exports = __webpack_public_path__ + "static/media/cylinder_bottom_yellow.54a52882.png";